import { Check } from 'lucide-react';

const steps = [
  { key: 'draft', label: 'Draft' },
  { key: 'submitted', label: 'Submitted' },
  { key: 'approved', label: 'Approved' },
  { key: 'paid', label: 'Paid' }
];

export default function WorkflowStepper({ currentStatus }) {
  const currentIndex = steps.findIndex(s => s.key === currentStatus);
  
  return (
    <div className="w-full py-6" data-testid="workflow-stepper">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isCurrent = index === currentIndex;
          const isPending = index > currentIndex;
          
          return (
            <div key={step.key} className="flex items-center flex-1">
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center font-semibold
                    ${isCompleted ? 'bg-emerald-500 text-white' : ''}
                    ${isCurrent ? 'bg-blue-500 text-white ring-4 ring-blue-100' : ''}
                    ${isPending ? 'bg-slate-200 text-slate-500' : ''}
                  `}
                  data-testid={`step-${step.key}`}
                >
                  {isCompleted ? <Check size={20} /> : index + 1}
                </div>
                <p
                  className={`
                    mt-2 text-xs font-medium
                    ${isCurrent ? 'text-blue-700' : ''}
                    ${isCompleted ? 'text-emerald-700' : ''}
                    ${isPending ? 'text-slate-500' : ''}
                  `}
                >
                  {step.label}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div
                  className={`
                    flex-1 h-1 mx-2 -mt-8
                    ${index < currentIndex ? 'bg-emerald-500' : 'bg-slate-200'}
                  `}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

